// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 767.98px) {
    .collapse:not(.show) {
        display: flex !important;
    }
}

@media (min-width: 767.98px) {
    .justify-content-end {
        display: flex !important;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/_layout/header/full-layout-navbar/full-layout-navbar.component.css"],"names":[],"mappings":"AAAA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ","sourcesContent":["@media (min-width: 767.98px) {\n    .collapse:not(.show) {\n        display: flex !important;\n    }\n}\n\n@media (min-width: 767.98px) {\n    .justify-content-end {\n        display: flex !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
